import React from 'react';
import { IProps } from './ScriptBlock.interface';
import { Base64HtmlRenderer } from '@/components/Base64HtmlRenderer/Base64HtmlRenderer.component';

export const ScriptBlock: React.FC<IProps> = ({
    className,
    content,
    base64EncodedText = false
}) => {
    return (
        <Base64HtmlRenderer
            content={content}
            base64Encoded={base64EncodedText}
            className={className}
        />
    );
};